import script from "./ReceivedDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceivedDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ReceivedDetailView.vue?vue&type=style&index=0&id=6af496aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af496aa"]])

export default __exports__